"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.SUBMENU_WIDTH=void 0;var SUBMENU_WIDTH=280;exports.SUBMENU_WIDTH=280;